import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';

@Component({
  selector: 'account-series',
  templateUrl: './series.component.html',
  styleUrls: ['./series.component.scss']
})
export class AccountSeriesComponent implements OnInit {

  form: boolean = false;
  serieForm: FormGroup;
  @Input() idDireccionEmpresa;
  @Input() nombreLugar;
  @Output() cancelar = new EventEmitter<any>();
  objetoGridConfiguration: any;
  objetosSelected: any;
  nombreReporte: string;
  verGrid: boolean = false;
  datosevent: any;
  descargarExcel = true;

  constructor(
    private _formBuilder: FormBuilder,
    private coalService: CoalService,
    private store: Store<AppState>
  ) {
    this.ObjectGrid();
  }

  ngOnInit(): void {
    this.serieForm = this._formBuilder.group({
      //idLugarExpedicion: [this.idDireccionEmpresa, Validators.required]
        serie: ['', Validators.required]
      , descripcion: ['', Validators.required]
      , folio: [null, Validators.min(0)]
    });

    this.getSeries();
  }

  openFormSerie() {
    this.form = true;
  }

  ObjectGrid() {
    let that = this;
    this.nombreReporte = 'Series';
    this.objetoGridConfiguration = {
        GridOptions: {
            paginacion: 20,
            pageSize: ['40', '60', '80', '100'],
        },
        ExportExcel: { enabled: false, fileName: 'Historico' },
        ColumnHiding: { hide: true },
        Checkbox: { checkboxmode: 'single' },
        Editing: { allowupdate: true, mode: 'cell' },
        Columnchooser: { columnchooser: true },
        SearchPanel: {
            visible: true,
            width: 200,
            placeholder: 'Buscar...',
            filterRow: true,
        },
        Scroll: { mode: 'infinite' },
        Color: null,
        Detail: { detail: true },
        ToolbarDetail: null,
        ToolBox: [
          {
            location: 'after',
            widget: 'dxButton',
            locateInMenu: 'auto',
            options: {
                width: 80,
                onClick: this.delete.bind(this),
                icon: '../../../assets/icons/borrar.png',
            },
            visible: true,
            name: 'simple',
          },
        ],
        Columns: [],
        Data: [],
        Columns1: [1],
        Data1: [],
        datosMessage(evento) {
            that.objetosSelected = evento.data;
        },
    };
    this.DataColumnsGrid();
  }

  DataColumnsGrid() {
    let columnsMulti = [];
      columnsMulti.push({
          caption: 'Serie',
          dataField: 'attributes.nombre',
          allowEditing: false,
          fixed: true,
      });
      columnsMulti.push({
          caption: 'Folio',
          dataField: 'attributes.folio',
          allowEditing: false,
      });
      columnsMulti.push({
          caption: 'Descripción',
          dataField: 'attributes.descripcion',
          allowEditing: false,
      });
    this.objetoGridConfiguration.Columns = columnsMulti;
  }

  getSeries() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`ope-direccion-empresas?filters[id]=${this.idDireccionEmpresa}&populate=ope_direccion_series`)
    .subscribe((res: any) => {
      this.objetoGridConfiguration.Data = res.data[0]?.attributes?.ope_direccion_series?.data;
      this.verGrid = true;
      this.store.dispatch(OcultarSpinner());
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    });
  }
  delete() {
    if(this.datosevent?.id) {
      this.store.dispatch(MostrarSpinner());
      this.coalService.deleteService(`ope-direccion-series/`, this.datosevent?.id)
      .subscribe((res: any) => {
        this.getSeries();
        this.form = false;
        this.store.dispatch(OcultarSpinner());
      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
      })
    }
  }

  errors: string = "";

  addSerie() {
    this.serieForm.markAllAsTouched();
    this.serieForm.updateValueAndValidity();
    if(this.serieForm.valid) {
        let data = {
            data: {
                nombre: this.serieForm.value.serie,
                descripcion: this.serieForm.value.descripcion,
                folio: this.serieForm.value.folio ?? 0,
                ope_direccion_empresa: this.idDireccionEmpresa
            }
        };
        this.store.dispatch(MostrarSpinner());
        this.coalService.postService('ope-direccion-series', data)
        .subscribe({ next: (res: any) => {
            this.form = false;
            this.getSeries();
            this.serieForm.reset();
            this.store.dispatch(OcultarSpinner());
        }, error: (error: any) => {
            this.store.dispatch(OcultarSpinner());
        }});
    }
  }

  close() {
    this.serieForm.markAsPristine();
    this.serieForm.reset();
    this.form = false;
  }

  datosMessage($event) {
    this.datosevent = $event.data[0];
  }

  return() {
    this.cancelar.emit()
  }
}
